export const SubjectCategory = {
  PERSON: 0,
  BUSINESS: 1
}

export const SubjectType = {
  PRIVATE_PERSON: 4,
  LEGAL_PERSON: 3,
  GOLD_OPERATOR: 1,
  BANK: 2
}

export const WarehouseKind = {
  COMPANY: 1,
  SUBJECT: 2,
  TRANSIT: 4
}

export const EntrySign = {
  PLUS: 1,
  MINUS: -1  
}